const pushParam = (params, label, value) => {
    if (value != null && value !== '') {
        params.push({ label, value: String(value) });
    }
};

export function mapCobraPosition(position = {}, labels = {}) {
    const params = Array.isArray(position.params) && position.params.length
        ? position.params
        : (() => {
            const fallback = [];
            pushParam(fallback, 'Side', position.side);
            pushParam(fallback, 'Qty', position.qty);
            return fallback;
        })();

    return {
        ...position,
        strategyLabel: labels.strategyLabel || position.strategyId,
        clientAlias: labels.clientAlias || position.clientId,
        params,
    };
}
